export default "__VITE_ASSET__CdgVyyFi__"